import React, { useEffect, useMemo, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Mail, Phone } from 'lucide-react'
function Contact(props) {
  const [showModal, setShowModal] = useState(props.showModal)
  const handleClose = () => {
    setShowModal(false)
    props.handleClose()
  }

  const sortedUnderwriters = useMemo(() => {
    const copied = [...props.contactUnderWriter]

    return copied.sort((a, b) => a.sortOrder - b.sortOrder)
  }, [props.contactUnderWriter])

  useEffect(() => {
    showModal !== props.showModal && setShowModal(props.showModal)
  }, [props.showModal])

  return (
    <div>
      <Modal
        backdropClassName="modal-backdrop-contact"
        dialogClassName="modal-dialog-contact"
        show={showModal}
        onHide={handleClose}
      >
        <Modal.Header className="modal-header-contact" />
        <Modal.Body className="modal-body-contact">
          <p style={{ fontSize: '1.25em' }}>For Quick Assistance</p>
          <p>Please contact one of the following underwriters</p>
          {sortedUnderwriters?.map((uw) => {
            const mailto = `mailto:${uw.email}`

            return (
              <ul key={uw.email}>
                <li style={{ listStyleType: 'none' }}>
                  {uw.firstName} {uw.lastName} at
                </li>
                <li
                  style={{
                    listStyleType: 'none',
                    fontWeight: 'bold',
                    marginLeft: '12px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Mail size={16} style={{ marginRight: 4 }}/>
                  <a href={mailto} style={{ color: '#040404' }}>
                    {uw.email}
                  </a>
                </li>
                <li
                  style={{
                    listStyleType: 'none',
                    fontWeight: 'bold',
                    marginLeft: '12px',
                    fontStyle: 'italic',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Phone size={16} style={{ marginRight: 4 }}/>
                  +{' '}
                  {uw.phoneExt} {uw.phone}
                </li>
              </ul>
            )
          })}
        </Modal.Body>
      </Modal>
    </div>
  )
}

const mapStateToProps = (state) => ({
  contactUnderWriter: state.auth.contactUnderWriter,
})

export default connect(mapStateToProps)(Contact)
